enum UPLOAD_PHOTO_STATES {
  take = 'TAKE',
  confirmTaking = 'CONFIRM_TAKING',
  upload = 'UPLOAD',
  crop = 'CROP',
  confirmUpload = 'CONFIRM_UPLOAD',
}

export {UPLOAD_PHOTO_STATES};
